import { useEffect, useState } from 'react'
import { languageToFlagCode, languageToCustomFlagCode, getFlagUrl } from '@/utils/flags'

interface LanguageFlagProps {
  isoCode: string
  size?: 's' | 'm' | 'l'
}

const SIZE_PX: Record<string, { width: number; height: number }> = {
  s: { width: 16, height: 12 },
  m: { width: 20, height: 15 },
  l: { width: 32, height: 24 },
}

export function LanguageFlag({ isoCode, size = 'm' }: LanguageFlagProps) {
  const [src, setSrc] = useState<string | null>(null)
  const code = languageToFlagCode(isoCode) ?? languageToCustomFlagCode(isoCode)

  useEffect(() => {
    if (!code) return
    getFlagUrl(code, size).then((url) => setSrc(url))
  }, [code, size])

  if (!src) return null

  const { width, height } = SIZE_PX[size]

  return (
    <span className="inline-flex items-center leading-[0] align-middle">
      <img
        src={src}
        alt=""
        width={width}
        height={height}
        className="block"
        style={{ width, height, objectFit: 'cover' }}
      />
    </span>
  )
}
